export const SIZES = {
  sidebarWidth: 240,
};
